import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";
import Banner from "components/organisms/Banner";

import FormContact from "./FormContact";

const ContactUs = ({ data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title={data?.title}
          description=""
          bgColor="bg-bbc-terms-policy"
          breadcrumbs={data?.breadcrumbs}
          titleProps={{
            className: "banner-default-title mb-10",
            textColor: "banner-title-gradient-color",
          }}
          leftClassName="lg:col-7"
          rightClassName="lg:col-5"
          rightContent={
            <Img
              src={data?.banner_image}
              width={595}
              height={468}
              alt="banner"
              wrapper={{
                className: "bbc-banner-image-bottom-0",
              }}
              className="w-full"
              priority={true}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <div className="row justify-between">
            <div className="mb-10 lg:col-7 lg:mb-0">
              {/* <Form>
                <FormContact description="All information entered on this form will be kept strictly confidential and subject to our privacy policy."/>
              </Form> */}
              {/* <Form>
                <FormContact region={data?.country} description="All information entered on this form will be kept strictly confidential and subject to our privacy policy."/>
              </Form> */}
              <Toast>
                <FormContact
                  region={data?.country}
                  description="All information entered on this form will be kept strictly confidential and subject to our privacy policy."
                />
              </Toast>
            </div>
            <div className="px-4 lg:col-4 ">
              <div className="flex flex-col justify-center">
                <Title className="title-h2 mb-6 font-semibold text-bbc-brand-800 lg:mb-10">
                  Get In Touch!
                </Title>
                <p className="mb-6 border-0 border-b border-b-bbc-neutral-600 pb-6">
                  Thank you for visiting us. At BBCIncorp, we always put the
                  client satisfaction on top of our business plan. If you have
                  any enquiries regarding our service, please feel free to
                  contact us. Our expert team will get back to you soonest.
                </p>
                {data?.contacts && data?.contacts.length > 0 && (
                  <div className="mb-6 border-0 border-b border-b-bbc-neutral-600">
                    {data.contacts.map((item, itemIdx) => (
                      <div className="mb-6 flex items-center" key={itemIdx}>
                        <div className="mr-3">
                          <Img
                            src={item?.icon}
                            alt={item?.altText}
                            width={48}
                            height={48}
                            className="h-full w-full"
                            wrapper={{ className: "block w-12" }}
                          />
                        </div>

                        <div>
                          <p className="text-black">{item?.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div>
                  <Title className="mb-6 text-2xl font-semibold leading-9 text-bbc-brand-800">
                    Business Working Hours
                  </Title>
                  <div className="mb-4 flex items-center">
                    <div className="mr-2">
                      <Img
                        src="/assets/icons/clock-outline.svg"
                        alt="clock-outline"
                        width={18}
                        height={18}
                        className="h-full w-full"
                        wrapper={{
                          className: "block ",
                          style: { width: "18px" },
                        }}
                      />
                    </div>

                    <div>
                      <p className="text-black ">
                        Monday &ndash; Friday 9am to 5.30pm
                      </p>
                    </div>
                  </div>
                  <div className="mb-4 flex items-center">
                    <div className="mr-2">
                      <Img
                        src="/assets/icons/calendar-outline.svg"
                        alt="calendar-outline"
                        width={18}
                        height={18}
                        className="h-full w-full"
                        wrapper={{
                          className: "block ",
                          style: { width: "18px" },
                        }}
                      />
                    </div>

                    <div>
                      <p className="text-black">Saturday &amp; Sunday-Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
